import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { i18nConfig } from './locales';

export const routing = defineRouting({ ...i18nConfig, localePrefix: 'always' });

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
